import {ThemeProvider, createTheme} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import {SnackbarProvider} from 'notistack';
import {createRoot} from 'react-dom/client';
import App from './App';

const theme = createTheme({
    palette: {
        primary: {
            main: '#631d79',
            contrastText: '#fff',
        },
        secondary: {
            main: '#ffc61e',
            contrastText: '#631d79',
        },
    },
});
const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element missing');
}

const root = createRoot(container);
root.render(
    <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={1}>
            <>
                <CssBaseline />
                <App />
            </>
        </SnackbarProvider>
    </ThemeProvider>,
);
